import 'unfetch'
import { logError } from 'tools/logging'

export async function query(details) {
  const { uri, accessToken, query, variables } = details

  if (!uri) {
    throw new Error('uri is required')
  }

  if (!accessToken) {
    throw new Error('accessToken is required')
  }

  if (!query) {
    throw new Error('query is required')
  }

  let result = null
  try {
    result = await fetch(uri, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        query: query,
        variables: variables,
      }),
    })
  } catch (exception) {
    logError(`Fetch Error for destination [${uri}]: ${exception}`)
  }

  if (result !== null) {
    try {
      if (result.status !== 200) {
        const resultText = await result.text()
        logError(`Non-200 status code [${result.status}] returned from ${uri}`, { apiResponse: resultText })
      } else {
        const json = await result.json()
        return json.data
      }
    } catch (exception) {
      logError(`Error parsing JSON response from ${uri}`, { exception: exception })
    }
  }

  return null
}



// WEBPACK FOOTER //
// ./src/tools/fetch.js